import type {Filter, SmartPv12Product} from '@smart/analytics';
import type {ProductSearchProduct} from '../../bff/product-search-model/create-product-search-model';
import type {Banner} from '../../bff/types';
import type {Facet} from '../components/facet-panel';
import {filterSelectedOptions} from './filter-selected-options';
import {getProductsForAnalytics} from './get-products-for-analytics';

export function getProductsAndFiltersForAnalytics(
  filterState: Facet[],
  products: (ProductSearchProduct | Banner)[],
  allProducts?: (ProductSearchProduct | Banner)[],
): {product: SmartPv12Product[]; filter: Filter[]} {
  const filteredOptions = filterSelectedOptions(filterState);
  const filteredProducts = getProductsForAnalytics(products, allProducts);

  return {
    filter: filteredOptions,
    product: filteredProducts,
  };
}
